import {
  PRODUCTION_NIELSEN_STATIC_APP_ID,
  DEVELOPMENT_NIELSEN_STATIC_APP_ID,
  GEOLOCATION_AU
} from '../../constants';
import { sendNielsenPageview } from '../../utils/nielsen';
import { loadScriptInHead } from '../../utils/dom';

export default function Nielsen(ad_data, geolocation, onProduction) {
  if (geolocation !== GEOLOCATION_AU) {
    return;
  }

  const appId = onProduction ? PRODUCTION_NIELSEN_STATIC_APP_ID : DEVELOPMENT_NIELSEN_STATIC_APP_ID;
  const debug = onProduction ? null : 'DEBUG';

  window.NOLBUNDLE = window.NOLBUNDLE || {
    nlsQ: function(e, o, c, r, s, i) { // eslint-disable-line no-unused-vars
      return loadScriptInHead('skip', `https://cdn-gl.imrworldwide.com/conf/${e}.js#name=${o}&ns=NOLBUNDLE`),
        window.NOLBUNDLE[o] = window.NOLBUNDLE[o] || {
          g: c || {},
          ggPM: function(e, c, r, s, i) {
            (window.NOLBUNDLE[o].q = window.NOLBUNDLE[o].q || []).push([e, c, r, s, i]);
          }
        },
        window.NOLBUNDLE[o];
    }
  };

  window.NOLBUNDLE.nlsQ(appId, 'Nielsen', { nol_sdkDebug: debug });

  sendNielsenPageview(ad_data);
}
